/* =======================================
   CUSTOM INPUT FILES
   ======================================= */

import ExportSettings from '../config/_export-settings';

export default class CustomInputFile {
	
	constructor(
		private $elem: JQuery,
		private settings: ExportSettings
	) {
	
		$elem.each( (index: number, elem: Element) => this.buildCustomInput($(elem)) );
		
	}
	
	/**
	 * Build the custom input file
	 *
	 * @param {JQuery} $elem
	 */
	buildCustomInput($elem: JQuery) {
		
		const $button: JQuery = $('<button/>', {
			type : 'button',
			class: 'btn btn-warning btn-file',
			text : this.settings.get('selectFile'),
		});
		
		const $fileInfo: JQuery = $('<div/>', {
			class: 'file-info',
			text : this.settings.get('noFileSelected'),
		});
	
		$elem.hide();
		$button.insertAfter($elem);
		$fileInfo.insertAfter($button);
		
		// Bind events after adding the elements to the DOM.
		$button.click( () => $elem.click() );
		
		this.$elem.change( () =>  {
			$fileInfo.text( $elem.val() ? $elem.val().split( '\\' ).pop() : this.settings.get('noFileSelected') );
			$button.blur();
		} );
		
		// Allow drag and drop of files.
		/*$button.add($fileInfo).on('dragenter dragover dragleave drop', (evt: JQueryEventObject) => {
			evt.preventDefault();
			evt.stopPropagation();
			
			if ('drop' === evt.type) {
				
				console.log(evt);
				
				const origEvent: any = evt.originalEvent;
				
				if (typeof origEvent.dataTransfer !== 'undefined') {
					const dt: DataTransfer = origEvent.dataTransfer,
					      files: FileList  = dt.files;
					
					for (const file in files ) {
						console.log(file);
					}
				}
				
			}
		});*/
	
	}
	
}


// WEBPACK FOOTER //
// ./assets/js/src/components/customInputFile.ts